<script lang="ts">
import type { Snippet } from 'svelte'

import { testIds } from '@/constants'

type Props = {
	isDisabled?: boolean
	isFaded?: boolean
	onClick: () => void
	children?: Snippet
}

let { isDisabled = false, isFaded = false, onClick, children }: Props = $props()
</script>

<!-- svelte-ignore a11y_click_events_have_key_events -->
<div
	role="button"
	tabindex={0}
	class={[
		`flex-center h-60px w-60px leading-normal mx-4 rounded-full cursor-pointer hover:scale-120 overflow-hidden transition-transform shadow-lg`,
		isDisabled && 'pointer-events-none',
		isFaded && 'opacity-10',
	]}
	onclick={onClick}
	data-testid={testIds.chatRatingEmojiButton}
>
	{@render children?.()}
</div>
